<template>
  <input
    :id="id"
    type="text"
    :value="value"
    class="input-text"
    :placeholder="placeholder"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'InputText',
  props: {
    id: { type: String, required: true },
    value: { type: String, default: null },
    placeholder: String
  }
}
</script>
